import React, {ReactElement} from "react";
import {AlgoliaWine, getCountry, getName, getRegion} from "./winePickerModel";
import {Checkbox} from "../../components/UIComponents/Checkbox";
import {Flag} from "../../components/UIComponents/Flag";
import {Language} from "../i18n/translations";

export interface WinePickerResultWineProps {
    selected: boolean
    onSetSelected: (wine: AlgoliaWine, selected: boolean) => void
    wine: AlgoliaWine
    language: Language
}

function _WinePickerResultWine(props: WinePickerResultWineProps): ReactElement {
    return (
        <button className={`flex h-[75px] py-2 items-center w-full
                            rounded bg-white border cursor-pointer
                            ${props.selected ? 'border-primary' :
                                               'border-gray-3'}`}
                onClick={() => props.onSetSelected(props.wine, !props.selected)}>
            <div className="px-2 flex-none h-6">
                <Checkbox checked={props.selected} setChecked={checked => props.onSetSelected(props.wine, checked)} />
            </div>
            <div className="self-stretch flex-none w-8 overflow-x-hidden text-center">
                {props.wine.img_url && (
                    <img
                        className="object-cover h-full"
                        src={props.wine.img_url}
                        alt={getName(props.language, props.wine)}
                    />
                )}
            </div>
            <div className="flex-auto flex flex-col justify-center gap-0.5">
                <div className="flex-none flex items-baseline gap-2">
                    <h3 className="font-barlow text-sm text-text font-medium">{props.wine.name}</h3>
                    <div className="font-barlow text-xs">{props.wine.year}</div>
                    <div className="text-light-text text-xs">|</div>
                    <div className="font-barlow text-xs">{props.wine.bottle_size}cl</div>
                </div>
                <div className="flex-none flex items-center gap-2">
                    <Flag country={props.wine.country} className="" />
                    <div className="leading-none">
                        <span className="font-fira-sans font-medium text-xs">{getCountry(props.language, props.wine)}</span>
                        <span className="font-barlow font-normal text-2xs">{getRegion(props.language, props.wine)}</span>
                    </div>
                </div>
            </div>
        </button>
    );
}

export const WinePickerResultWine = React.memo(_WinePickerResultWine, (prevProps, nextProps) => {
    return prevProps.selected === nextProps.selected
        && prevProps.onSetSelected === nextProps.onSetSelected
        && prevProps.wine.objectID === nextProps.wine.objectID
        && prevProps.language === nextProps.language;
});
